import { render, staticRenderFns } from "./AddEditDocument.vue?vue&type=template&id=13ac5c78&scoped=true&"
import script from "./AddEditDocument.vue?vue&type=script&lang=js&"
export * from "./AddEditDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac5c78",
  null
  
)

export default component.exports